<app-header></app-header>

<!-- <link href="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css" rel="stylesheet" id="bootstrap-css">
<script src="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/js/bootstrap.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script> -->

<div class="container-xxl">

  <section class="banner d-flex justify-content-center align-items-center text-center">
    <div class="content" data-aos="zoom-in" data-aos-duration="2000">
      <div class="title">
        <span>الدورات التدريبية</span>
      </div>
    
      <div class="links">
        <a class="text-decoration-none" href="/home"> الرئيسية </a>
        <span>/</span>
        <a class="text-decoration-none" href="/getAllCourses"> الدورات التدريبية </a>
        <span> / {{ course.tittle }}</span>
      </div>
    </div>
  </section>

  <div class="container emp-profile">
    <form class="course-details" method="post" data-aos="fade-left" data-aos-duration="2000">
      <div class="row">
        <div class="col-md-4">
          <div class="profile-work d-flex justify-content-center align-items-center">           
              <img class="img-fluid" src="https://khairokom-uploadfiles.azurewebsites.net/files/{{course.image}}" alt="تحميل الصورة" />          
          </div>
        </div>

        <div class="col-md-8 ">
          <div class="tab-content profile-tab" id="myTabContent">
            <div
              class="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            ></div>
            <div class="row">
              <div class="col-md-4">
                <label class="title">اسم الدورة التدريبية</label>
              </div>
              <div class="text col-md-8">
                {{ course.tittle }}
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-6">
                <label>الصورة</label>
              </div>
              <div class="col-md-6">
                <img src="{{ course.image }}" alt="تحميل الصورة" />
              </div>
            </div> -->
            <div class="row">
              <div class="col-md-4">
                <label class="title">الوصـــف</label>
              </div>
              <div class="text col-md-8">
                <p>{{ course.description }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label class="title">القســـم</label>
              </div>
              <div class="text col-md-8">
                <p>{{ courseCategoryTitle }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label class="title">التقييم</label>
              </div>
              <!-- (mouseover)="changeColor=true" (mouseout)="changeColor=false" -->
              <div class="col-md-8" (mouseover)="changeColor=true" (mouseout)="changeColor=false">              
                <i *ngFor='let in of counter(AbsCourseStars) ;let i = index' class="filledStar fas fa-star" ></i>
                <i *ngFor='let in of counter(5-AbsCourseStars) ;let i = index' class="star fas fa-star" ></i>                
              </div>
            </div>
            <!-- (mouseover)="changeColor=true" (mouseout)="changeColor=false" -->                       

          <div class="mt-5">
            <button class="btn btn-warning" (click)="notifyWithNewWaitingStudent()" *ngIf="userName!='0000' && studentClasses.length==0">
              
              سجل كطالب
            </button>&nbsp; &nbsp; &nbsp;
            <button class="btn btn-warning" (click)="notifyWithNewWaitingTeacher()" *ngIf="userName!='0000'">
              درّس كمعلم
            </button>&nbsp; &nbsp; &nbsp;
            <button class="btn btn-dark" routerLink="/detailedFeedback/{{courseId}}" *ngIf="userName!='0000'">
              للمزيد من التقييمـــات
            </button> 
          </div>
          </div>
          

        </div>
      </div>
    </form>
  
    <div class="groups" data-aos="fade-right" data-aos-duration="2000">
        <div class="teacher">
          <h2 class="">مجموعاتي كمعلم</h2>
          <table class="table table-bordered table-hover">
            <thead class="thead-light">
              <tr>
                <th>اسم المجموعة</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let teacherCourseClass of teacherCourseClasses">
                <td  style="cursor: pointer;" routerLink="/getClassById/{{teacherCourseClass._id}}">{{teacherCourseClass.Number}}</td>
              </tr>
            </tbody>
          </table>
        </div>
    
        <div class="student">
          <h2 class="">مجموعاتي كطالب</h2>
          <table class="table table-bordered table-hover">
            <thead class="thead-light">
              <tr>
                <th>اسم المجموعة</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let studnentCourseClass of studnentCourseClasses">
                <td  style="cursor: pointer;" routerLink="/getClassById/{{studnentCourseClass._id}}">{{studnentCourseClass.Number}}</td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
  
    <div data-aos="fade-up" data-aos-duration="2000">
      <h2 class="font-weight-bold"> <i style="color: #757575;" class="far fa-comments"></i>&nbsp; التعليقات</h2>
    <div class="comments mt-4 mb-4">
      <div class="row" *ngFor="let comment of courseComments">     
        <div class="comment-image col-md-1 d-flex justify-content-center align-items-center">
          <img class="img-fluid" src="https://www.materialui.co/materialIcons/action/account_circle_grey_192x192.png" width="50px">
        </div>
  
        <div class="coment-text col-md-11 mt-3 d-flex align-items-center">                      

          <div style="margin-top: -40px;">
            <button *ngIf="comment.userID==userId||userIsAdmin" style="height: 20px;width: 20px;padding: 0px;"
          class="btn btn-danger" (click)="deleteComment(comment._id)">X</button>
          </div>

            <div class="col-sm">
              <a routerLink="/profile/{{ comment.userID }}">          
                <b>{{ comment.userName }} </b>
              </a>
              <p>{{ comment.content }}</p>
            </div>            

          </div>       
      </div>
    </div>

    <!-- <h3 class="mt-5">اترك تعليقاً</h3> -->
  <form  *ngIf="userName!='0000'" class="buttons" [formGroup]="addCommentForm" enctype="multipart/form-data">
    <div class="form-group">
      <!-- <label>التعليق</label> -->
      <input formControlName="content" type="text" class="form-control write mt-4 mb-2" placeholder="اترك تعليقاً" />
    </div>

    <input
      type="submit"
      class="submit btn mb-5"
      value="أضف تعليقاً"
      (click)="AddComment()"
    />
  </form>
    </div>
  </div> 

  
</div>

<app-footer></app-footer>
